<!-- <nb-layout> -->
    <router-outlet></router-outlet>
<!-- </nb-layout> -->
